import { useSendbirdStateContext } from '@sendbird/uikit-react';
import sendbirdSelectors from '@sendbird/uikit-react/sendbirdSelectors';
import React, { useEffect } from 'react';

import type { SendbirdSdk } from '../types/GuideMessaging';

interface SendbirdSdkProviderProps {
    sendbirdSdk: SendbirdSdk;
    setSendbirdSdk: React.Dispatch<React.SetStateAction<SendbirdSdk>>;
    children?: React.ReactNode;
}

const SendbirdSdkProvider = ({
    sendbirdSdk,
    setSendbirdSdk,
    children,
}: SendbirdSdkProviderProps) => {
    const globalStore = useSendbirdStateContext();
    const sdkStore = globalStore.stores.sdkStore;
    const isSdkInitialized =
        sdkStore != null && !sdkStore.loading && sdkStore.initialized;

    useEffect(() => {
        if (!isSdkInitialized) {
            return;
        }

        if (sendbirdSdk.sdk != null) {
            return;
        }

        const sdkInstance = sendbirdSelectors.getSdk(globalStore);
        setSendbirdSdk({ sdk: sdkInstance, isLoading: false });
    }, [isSdkInitialized]);

    return <>{children}</>;
};

export default SendbirdSdkProvider;
